// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0

package io.github.suqi8.coui.kmp.icon.extended

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathNode
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.icon.COUIIcons

val COUIIcons.Contacts: ImageVector
    get() = COUIIcons.Regular.Contacts

val COUIIcons.Light.Contacts: ImageVector
    get() {
        if (_contactsLight != null) return _contactsLight!!
        _contactsLight = ImageVector.Builder(
            name = "Contacts.Light",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1155.6f,
            viewportHeight = 1155.6f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1155.6f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1024.3f, 105.8f),
                        PathNode.QuadTo(1044.3f, 115.8f, 1051.3f, 134.8f),
                        PathNode.QuadTo(1056.3f, 144.8f, 1057.8f, 161.3f),
                        PathNode.QuadTo(1059.3f, 177.8f, 1059.3f, 214.8f),
                        PathNode.QuadTo(1059.3f, 259.8f, 1057.3f, 283.8f),
                        PathNode.QuadTo(1055.3f, 307.8f, 1048.3f, 327.8f),
                        PathNode.QuadTo(1042.3f, 345.8f, 1027.3f, 365.8f),
                        PathNode.QuadTo(1012.3f, 385.8f, 996.3f, 397.8f),
                        PathNode.QuadTo(978.3f, 411.8f, 961.3f, 420.3f),
                        PathNode.QuadTo(944.3f, 428.8f, 914.3f, 438.8f),
                        PathNode.QuadTo(747.3f, 493.8f, 578.3f, 493.8f),
                        PathNode.QuadTo(407.3f, 493.8f, 242.3f, 438.8f),
                        PathNode.QuadTo(210.3f, 427.8f, 193.3f, 419.8f),
                        PathNode.QuadTo(176.3f, 411.8f, 158.3f, 398.8f),
                        PathNode.QuadTo(143.3f, 386.8f, 128.3f, 366.3f),
                        PathNode.QuadTo(113.3f, 345.8f, 106.3f, 327.8f),
                        PathNode.QuadTo(100.3f, 307.8f, 98.3f, 284.8f),
                        PathNode.QuadTo(96.3f, 261.8f, 96.3f, 214.8f),
                        PathNode.QuadTo(96.3f, 177.8f, 97.8f, 161.3f),
                        PathNode.QuadTo(99.3f, 144.8f, 104.3f, 134.8f),
                        PathNode.QuadTo(112.3f, 114.8f, 132.3f, 105.8f),
                        PathNode.QuadTo(142.3f, 99.8f, 157.8f, 98.8f),
                        PathNode.QuadTo(173.3f, 97.8f, 211.3f, 97.8f),
                        PathNode.HorizontalTo(944.3f),
                        PathNode.QuadTo(982.3f, 97.8f, 997.8f, 98.8f),
                        PathNode.QuadTo(1013.3f, 99.8f, 1024.3f, 105.8f),
                        PathNode.Close,
                        PathNode.MoveTo(155.3f, 188.8f),
                        PathNode.VerticalTo(224.8f),
                        PathNode.QuadTo(155.3f, 257.8f, 156.8f, 274.3f),
                        PathNode.QuadTo(158.3f, 290.8f, 163.3f, 304.8f),
                        PathNode.QuadTo(175.3f, 335.8f, 196.3f, 350.8f),
                        PathNode.QuadTo(207.3f, 360.8f, 220.3f, 366.8f),
                        PathNode.QuadTo(233.3f, 372.8f, 258.3f, 380.8f),
                        PathNode.QuadTo(410.3f, 434.8f, 572.3f, 434.8f),
                        PathNode.QuadTo(737.3f, 434.8f, 902.3f, 374.8f),
                        PathNode.LineTo(912.3f, 370.8f),
                        PathNode.QuadTo(927.3f, 364.8f, 939.8f, 358.3f),
                        PathNode.QuadTo(952.3f, 351.8f, 961.3f, 343.8f),
                        PathNode.QuadTo(984.3f, 323.8f, 992.3f, 296.8f),
                        PathNode.QuadTo(997.3f, 282.8f, 998.8f, 265.8f),
                        PathNode.QuadTo(1000.3f, 248.8f, 1000.3f, 219.8f),
                        PathNode.VerticalTo(187.8f),
                        PathNode.QuadTo(1000.3f, 170.8f, 994.3f, 164.3f),
                        PathNode.QuadTo(988.3f, 157.8f, 972.3f, 157.8f),
                        PathNode.HorizontalTo(185.3f),
                        PathNode.QuadTo(168.3f, 157.8f, 161.8f, 164.3f),
                        PathNode.QuadTo(155.3f, 170.8f, 155.3f, 188.8f),
                        PathNode.Close,
                        PathNode.MoveTo(813.3f, 821.8f),
                        PathNode.QuadTo(813.3f, 885.8f, 781.3f, 939.8f),
                        PathNode.QuadTo(749.3f, 993.8f, 695.3f, 1025.8f),
                        PathNode.QuadTo(641.3f, 1057.8f, 578.3f, 1057.8f),
                        PathNode.QuadTo(514.3f, 1057.8f, 460.3f, 1025.8f),
                        PathNode.QuadTo(406.3f, 993.8f, 374.3f, 939.8f),
                        PathNode.QuadTo(342.3f, 885.8f, 342.3f, 821.8f),
                        PathNode.QuadTo(342.3f, 757.8f, 373.8f, 703.8f),
                        PathNode.QuadTo(405.3f, 649.8f, 459.8f, 618.3f),
                        PathNode.QuadTo(514.3f, 586.8f, 578.3f, 586.8f),
                        PathNode.QuadTo(642.3f, 586.8f, 696.3f, 618.3f),
                        PathNode.QuadTo(750.3f, 649.8f, 781.8f, 703.8f),
                        PathNode.QuadTo(813.3f, 757.8f, 813.3f, 821.8f),
                        PathNode.Close,
                        PathNode.MoveTo(401.3f, 821.8f),
                        PathNode.QuadTo(401.3f, 869.8f, 425.3f, 910.3f),
                        PathNode.QuadTo(449.3f, 950.8f, 489.8f, 974.3f),
                        PathNode.QuadTo(530.3f, 997.8f, 578.3f, 997.8f),
                        PathNode.QuadTo(625.3f, 997.8f, 665.8f, 974.3f),
                        PathNode.QuadTo(706.3f, 950.8f, 730.3f, 910.3f),
                        PathNode.QuadTo(754.3f, 869.8f, 754.3f, 821.8f),
                        PathNode.QuadTo(754.3f, 773.8f, 730.3f, 733.3f),
                        PathNode.QuadTo(706.3f, 692.8f, 665.8f, 669.3f),
                        PathNode.QuadTo(625.3f, 645.8f, 578.3f, 645.8f),
                        PathNode.QuadTo(530.3f, 645.8f, 489.8f, 669.3f),
                        PathNode.QuadTo(449.3f, 692.8f, 425.3f, 733.3f),
                        PathNode.QuadTo(401.3f, 773.8f, 401.3f, 821.8f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _contactsLight!!
    }

private var _contactsLight: ImageVector? = null

val COUIIcons.Normal.Contacts: ImageVector
    get() {
        if (_contactsNormal != null) return _contactsNormal!!
        _contactsNormal = ImageVector.Builder(
            name = "Contacts.Normal",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1177.0f,
            viewportHeight = 1177.0f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1177.0f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1038.5f, 108.3f),
                        PathNode.QuadTo(1061.2f, 120.3f, 1070.3f, 142.1f),
                        PathNode.QuadTo(1076.0f, 153.5f, 1077.5f, 170.0f),
                        PathNode.QuadTo(1079.0f, 186.5f, 1079.0f, 225.5f),
                        PathNode.QuadTo(1079.0f, 274.6f, 1077.3f, 297.6f),
                        PathNode.QuadTo(1075.7f, 320.6f, 1068.0f, 341.3f),
                        PathNode.QuadTo(1061.3f, 360.6f, 1045.6f, 382.4f),
                        PathNode.QuadTo(1029.9f, 404.1f, 1013.2f, 416.8f),
                        PathNode.QuadTo(995.9f, 430.8f, 978.9f, 438.6f),
                        PathNode.QuadTo(961.9f, 446.4f, 927.8f, 457.8f),
                        PathNode.QuadTo(761.5f, 513.5f, 589.0f, 513.5f),
                        PathNode.QuadTo(415.3f, 513.5f, 250.3f, 457.8f),
                        PathNode.QuadTo(214.8f, 446.1f, 197.8f, 438.4f),
                        PathNode.QuadTo(180.8f, 430.8f, 163.5f, 417.1f),
                        PathNode.QuadTo(147.1f, 403.7f, 131.5f, 382.2f),
                        PathNode.QuadTo(115.8f, 360.6f, 108.8f, 341.3f),
                        PathNode.QuadTo(101.4f, 320.6f, 99.7f, 297.9f),
                        PathNode.QuadTo(98.1f, 275.3f, 98.1f, 225.5f),
                        PathNode.QuadTo(98.1f, 186.5f, 99.6f, 170.0f),
                        PathNode.QuadTo(101.1f, 153.5f, 106.8f, 142.1f),
                        PathNode.QuadTo(116.1f, 120.0f, 138.9f, 108.3f),
                        PathNode.QuadTo(150.3f, 102.3f, 166.8f, 100.9f),
                        PathNode.QuadTo(183.3f, 99.6f, 222.0f, 99.6f),
                        PathNode.HorizontalTo(955.0f),
                        PathNode.QuadTo(993.7f, 99.6f, 1010.2f, 100.9f),
                        PathNode.QuadTo(1026.8f, 102.3f, 1038.5f, 108.3f),
                        PathNode.Close,
                        PathNode.MoveTo(175.0f, 207.8f),
                        PathNode.VerticalTo(235.5f),
                        PathNode.QuadTo(175.0f, 267.8f, 176.1f, 283.0f),
                        PathNode.QuadTo(177.3f, 298.1f, 182.3f, 311.4f),
                        PathNode.QuadTo(193.6f, 339.0f, 212.5f, 354.0f),
                        PathNode.QuadTo(223.5f, 363.3f, 235.8f, 369.3f),
                        PathNode.QuadTo(248.1f, 375.3f, 271.8f, 382.6f),
                        PathNode.QuadTo(419.0f, 436.6f, 580.3f, 436.6f),
                        PathNode.QuadTo(751.5f, 436.6f, 909.6f, 375.2f),
                        PathNode.LineTo(919.6f, 371.2f),
                        PathNode.QuadTo(934.6f, 365.2f, 946.1f, 359.1f),
                        PathNode.QuadTo(957.5f, 352.9f, 965.8f, 345.6f),
                        PathNode.QuadTo(986.8f, 327.0f, 994.8f, 302.0f),
                        PathNode.QuadTo(999.8f, 289.4f, 1000.9f, 274.5f),
                        PathNode.QuadTo(1002.1f, 259.5f, 1002.1f, 229.1f),
                        PathNode.VerticalTo(207.5f),
                        PathNode.QuadTo(1002.1f, 188.4f, 996.4f, 182.9f),
                        PathNode.QuadTo(990.8f, 177.5f, 972.0f, 177.5f),
                        PathNode.HorizontalTo(205.6f),
                        PathNode.QuadTo(186.6f, 177.5f, 180.8f, 182.9f),
                        PathNode.QuadTo(175.0f, 188.4f, 175.0f, 207.8f),
                        PathNode.Close,
                        PathNode.MoveTo(833.0f, 832.5f),
                        PathNode.QuadTo(833.0f, 898.6f, 799.9f, 955.0f),
                        PathNode.QuadTo(766.9f, 1011.4f, 710.8f, 1044.4f),
                        PathNode.QuadTo(654.8f, 1077.5f, 589.0f, 1077.5f),
                        PathNode.QuadTo(522.3f, 1077.5f, 466.2f, 1044.4f),
                        PathNode.QuadTo(410.1f, 1011.4f, 377.1f, 955.0f),
                        PathNode.QuadTo(344.1f, 898.6f, 344.1f, 832.5f),
                        PathNode.QuadTo(344.1f, 766.5f, 377.0f, 710.4f),
                        PathNode.QuadTo(409.8f, 654.3f, 466.1f, 621.5f),
                        PathNode.QuadTo(522.3f, 588.6f, 589.0f, 588.6f),
                        PathNode.QuadTo(655.1f, 588.6f, 711.1f, 621.5f),
                        PathNode.QuadTo(767.2f, 654.3f, 800.1f, 710.4f),
                        PathNode.QuadTo(833.0f, 766.5f, 833.0f, 832.5f),
                        PathNode.Close,
                        PathNode.MoveTo(421.0f, 832.5f),
                        PathNode.QuadTo(421.0f, 877.8f, 443.6f, 916.2f),
                        PathNode.QuadTo(466.2f, 954.6f, 505.0f, 977.1f),
                        PathNode.QuadTo(543.8f, 999.6f, 589.0f, 999.6f),
                        PathNode.QuadTo(634.0f, 999.6f, 672.4f, 977.1f),
                        PathNode.QuadTo(710.8f, 954.6f, 733.5f, 916.2f),
                        PathNode.QuadTo(756.1f, 877.8f, 756.1f, 832.5f),
                        PathNode.QuadTo(756.1f, 787.3f, 733.5f, 748.8f),
                        PathNode.QuadTo(710.8f, 710.4f, 672.4f, 687.9f),
                        PathNode.QuadTo(634.0f, 665.5f, 589.0f, 665.5f),
                        PathNode.QuadTo(543.8f, 665.5f, 505.0f, 687.9f),
                        PathNode.QuadTo(466.2f, 710.4f, 443.6f, 748.8f),
                        PathNode.QuadTo(421.0f, 787.3f, 421.0f, 832.5f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _contactsNormal!!
    }

private var _contactsNormal: ImageVector? = null

val COUIIcons.Regular.Contacts: ImageVector
    get() {
        if (_contactsRegular != null) return _contactsRegular!!
        _contactsRegular = ImageVector.Builder(
            name = "Contacts.Regular",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1186.8f,
            viewportHeight = 1186.8f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1186.8f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1044.9f, 109.4f),
                        PathNode.QuadTo(1068.9f, 122.4f, 1078.9f, 145.4f),
                        PathNode.QuadTo(1084.9f, 157.4f, 1086.4f, 173.9f),
                        PathNode.QuadTo(1087.9f, 190.4f, 1087.9f, 230.4f),
                        PathNode.QuadTo(1087.9f, 281.4f, 1086.4f, 303.9f),
                        PathNode.QuadTo(1084.9f, 326.4f, 1076.9f, 347.4f),
                        PathNode.QuadTo(1069.9f, 367.4f, 1053.9f, 389.9f),
                        PathNode.QuadTo(1037.9f, 412.4f, 1020.9f, 425.4f),
                        PathNode.QuadTo(1003.9f, 439.4f, 986.9f, 446.9f),
                        PathNode.QuadTo(969.9f, 454.4f, 933.9f, 466.4f),
                        PathNode.QuadTo(767.9f, 522.4f, 593.9f, 522.4f),
                        PathNode.QuadTo(418.9f, 522.4f, 253.9f, 466.4f),
                        PathNode.QuadTo(216.9f, 454.4f, 199.9f, 446.9f),
                        PathNode.QuadTo(182.9f, 439.4f, 165.9f, 425.4f),
                        PathNode.QuadTo(148.9f, 411.4f, 132.9f, 389.4f),
                        PathNode.QuadTo(116.9f, 367.4f, 109.9f, 347.4f),
                        PathNode.QuadTo(101.9f, 326.4f, 100.4f, 303.9f),
                        PathNode.QuadTo(98.9f, 281.4f, 98.9f, 230.4f),
                        PathNode.QuadTo(98.9f, 190.4f, 100.4f, 173.9f),
                        PathNode.QuadTo(101.9f, 157.4f, 107.9f, 145.4f),
                        PathNode.QuadTo(117.9f, 122.4f, 141.9f, 109.4f),
                        PathNode.QuadTo(153.9f, 103.4f, 170.9f, 101.9f),
                        PathNode.QuadTo(187.9f, 100.4f, 226.9f, 100.4f),
                        PathNode.HorizontalTo(959.9f),
                        PathNode.QuadTo(998.9f, 100.4f, 1015.9f, 101.9f),
                        PathNode.QuadTo(1032.9f, 103.4f, 1044.9f, 109.4f),
                        PathNode.Close,
                        PathNode.MoveTo(183.9f, 216.4f),
                        PathNode.VerticalTo(240.4f),
                        PathNode.QuadTo(183.9f, 272.4f, 184.9f, 286.9f),
                        PathNode.QuadTo(185.9f, 301.4f, 190.9f, 314.4f),
                        PathNode.QuadTo(201.9f, 340.4f, 219.9f, 355.4f),
                        PathNode.QuadTo(230.9f, 364.4f, 242.9f, 370.4f),
                        PathNode.QuadTo(254.9f, 376.4f, 277.9f, 383.4f),
                        PathNode.QuadTo(422.9f, 437.4f, 583.9f, 437.4f),
                        PathNode.QuadTo(757.9f, 437.4f, 912.9f, 375.4f),
                        PathNode.LineTo(922.9f, 371.4f),
                        PathNode.QuadTo(937.9f, 365.4f, 948.9f, 359.4f),
                        PathNode.QuadTo(959.9f, 353.4f, 967.9f, 346.4f),
                        PathNode.QuadTo(987.9f, 328.4f, 995.9f, 304.4f),
                        PathNode.QuadTo(1000.9f, 292.4f, 1001.9f, 278.4f),
                        PathNode.QuadTo(1002.9f, 264.4f, 1002.9f, 233.4f),
                        PathNode.VerticalTo(216.4f),
                        PathNode.QuadTo(1002.9f, 196.4f, 997.4f, 191.4f),
                        PathNode.QuadTo(991.9f, 186.4f, 971.9f, 186.4f),
                        PathNode.HorizontalTo(214.9f),
                        PathNode.QuadTo(194.9f, 186.4f, 189.4f, 191.4f),
                        PathNode.QuadTo(183.9f, 196.4f, 183.9f, 216.4f),
                        PathNode.Close,
                        PathNode.MoveTo(841.9f, 837.4f),
                        PathNode.QuadTo(841.9f, 904.4f, 808.4f, 961.9f),
                        PathNode.QuadTo(774.9f, 1019.4f, 717.9f, 1052.9f),
                        PathNode.QuadTo(660.9f, 1086.4f, 593.9f, 1086.4f),
                        PathNode.QuadTo(525.9f, 1086.4f, 468.9f, 1052.9f),
                        PathNode.QuadTo(411.9f, 1019.4f, 378.4f, 961.9f),
                        PathNode.QuadTo(344.9f, 904.4f, 344.9f, 837.4f),
                        PathNode.QuadTo(344.9f, 770.4f, 378.4f, 713.4f),
                        PathNode.QuadTo(411.9f, 656.4f, 468.9f, 622.9f),
                        PathNode.QuadTo(525.9f, 589.4f, 593.9f, 589.4f),
                        PathNode.QuadTo(660.9f, 589.4f, 717.9f, 622.9f),
                        PathNode.QuadTo(774.9f, 656.4f, 808.4f, 713.4f),
                        PathNode.QuadTo(841.9f, 770.4f, 841.9f, 837.4f),
                        PathNode.Close,
                        PathNode.MoveTo(429.9f, 837.4f),
                        PathNode.QuadTo(429.9f, 881.4f, 451.9f, 918.9f),
                        PathNode.QuadTo(473.9f, 956.4f, 511.9f, 978.4f),
                        PathNode.QuadTo(549.9f, 1000.4f, 593.9f, 1000.4f),
                        PathNode.QuadTo(637.9f, 1000.4f, 675.4f, 978.4f),
                        PathNode.QuadTo(712.9f, 956.4f, 734.9f, 918.9f),
                        PathNode.QuadTo(756.9f, 881.4f, 756.9f, 837.4f),
                        PathNode.QuadTo(756.9f, 793.4f, 734.9f, 755.9f),
                        PathNode.QuadTo(712.9f, 718.4f, 675.4f, 696.4f),
                        PathNode.QuadTo(637.9f, 674.4f, 593.9f, 674.4f),
                        PathNode.QuadTo(549.9f, 674.4f, 511.9f, 696.4f),
                        PathNode.QuadTo(473.9f, 718.4f, 451.9f, 755.9f),
                        PathNode.QuadTo(429.9f, 793.4f, 429.9f, 837.4f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _contactsRegular!!
    }

private var _contactsRegular: ImageVector? = null

val COUIIcons.Medium.Contacts: ImageVector
    get() {
        if (_contactsMedium != null) return _contactsMedium!!
        _contactsMedium = ImageVector.Builder(
            name = "Contacts.Medium",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1206.6f,
            viewportHeight = 1206.6f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1206.6f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1058.3f, 111.0f),
                        PathNode.QuadTo(1084.1f, 124.6f, 1095.8f, 150.6f),
                        PathNode.QuadTo(1103.0f, 163.8f, 1104.5f, 181.1f),
                        PathNode.QuadTo(1106.0f, 198.5f, 1106.0f, 239.1f),
                        PathNode.QuadTo(1106.0f, 284.8f, 1104.2f, 308.5f),
                        PathNode.QuadTo(1102.4f, 332.2f, 1094.4f, 353.8f),
                        PathNode.QuadTo(1087.4f, 374.3f, 1070.8f, 397.7f),
                        PathNode.QuadTo(1054.3f, 421.1f, 1036.1f, 435.3f),
                        PathNode.QuadTo(1017.9f, 449.3f, 1000.3f, 457.4f),
                        PathNode.QuadTo(982.7f, 465.5f, 946.7f, 477.5f),
                        PathNode.QuadTo(779.5f, 534.0f, 603.8f, 534.0f),
                        PathNode.QuadTo(426.4f, 534.0f, 260.8f, 477.5f),
                        PathNode.QuadTo(224.4f, 465.5f, 206.5f, 457.4f),
                        PathNode.QuadTo(188.7f, 449.3f, 170.5f, 435.3f),
                        PathNode.QuadTo(152.3f, 421.3f, 136.0f, 398.4f),
                        PathNode.QuadTo(119.7f, 375.5f, 112.1f, 353.8f),
                        PathNode.QuadTo(104.1f, 332.2f, 102.3f, 308.5f),
                        PathNode.QuadTo(100.5f, 284.8f, 100.5f, 239.1f),
                        PathNode.QuadTo(100.5f, 198.5f, 102.0f, 181.1f),
                        PathNode.QuadTo(103.5f, 163.8f, 110.7f, 150.6f),
                        PathNode.QuadTo(122.5f, 124.6f, 148.3f, 111.0f),
                        PathNode.QuadTo(161.4f, 104.5f, 179.6f, 103.0f),
                        PathNode.QuadTo(197.8f, 101.5f, 236.8f, 101.5f),
                        PathNode.HorizontalTo(969.8f),
                        PathNode.QuadTo(1011.1f, 101.5f, 1028.1f, 103.0f),
                        PathNode.QuadTo(1045.1f, 104.5f, 1058.3f, 111.0f),
                        PathNode.Close,
                        PathNode.MoveTo(202.0f, 226.9f),
                        PathNode.VerticalTo(249.1f),
                        PathNode.QuadTo(202.0f, 273.5f, 203.0f, 288.3f),
                        PathNode.QuadTo(204.0f, 303.0f, 208.4f, 314.9f),
                        PathNode.QuadTo(218.3f, 339.1f, 235.1f, 352.9f),
                        PathNode.QuadTo(244.9f, 361.3f, 256.3f, 366.8f),
                        PathNode.QuadTo(267.7f, 372.2f, 290.7f, 379.8f),
                        PathNode.QuadTo(433.4f, 432.6f, 593.8f, 432.6f),
                        PathNode.QuadTo(767.2f, 432.6f, 919.8f, 371.2f),
                        PathNode.LineTo(929.3f, 367.2f),
                        PathNode.QuadTo(943.7f, 361.2f, 954.1f, 355.8f),
                        PathNode.QuadTo(964.5f, 350.3f, 972.5f, 343.9f),
                        PathNode.QuadTo(990.7f, 327.7f, 998.7f, 305.5f),
                        PathNode.QuadTo(1002.5f, 294.6f, 1003.5f, 280.0f),
                        PathNode.QuadTo(1004.5f, 265.5f, 1004.5f, 242.1f),
                        PathNode.VerticalTo(226.9f),
                        PathNode.QuadTo(1004.5f, 211.6f, 1000.2f, 207.5f),
                        PathNode.QuadTo(995.9f, 203.3f, 980.6f, 203.3f),
                        PathNode.HorizontalTo(226.0f),
                        PathNode.QuadTo(210.7f, 203.3f, 206.3f, 207.5f),
                        PathNode.QuadTo(202.0f, 211.6f, 202.0f, 226.9f),
                        PathNode.Close,
                        PathNode.MoveTo(859.4f, 849.0f),
                        PathNode.QuadTo(859.4f, 917.8f, 825.0f, 976.8f),
                        PathNode.QuadTo(790.7f, 1035.8f, 731.9f, 1070.4f),
                        PathNode.QuadTo(673.1f, 1105.1f, 603.8f, 1105.1f),
                        PathNode.QuadTo(534.0f, 1105.1f, 475.0f, 1070.4f),
                        PathNode.QuadTo(415.9f, 1035.8f, 381.5f, 976.8f),
                        PathNode.QuadTo(347.1f, 917.8f, 347.1f, 849.0f),
                        PathNode.QuadTo(347.1f, 779.7f, 381.5f, 720.9f),
                        PathNode.QuadTo(415.9f, 662.2f, 475.0f, 627.8f),
                        PathNode.QuadTo(534.0f, 593.4f, 603.8f, 593.4f),
                        PathNode.QuadTo(673.1f, 593.4f, 731.9f, 627.8f),
                        PathNode.QuadTo(790.7f, 662.2f, 825.0f, 720.9f),
                        PathNode.QuadTo(859.4f, 779.7f, 859.4f, 849.0f),
                        PathNode.Close,
                        PathNode.MoveTo(447.4f, 849.0f),
                        PathNode.QuadTo(447.4f, 890.7f, 468.5f, 926.4f),
                        PathNode.QuadTo(489.7f, 962.2f, 525.6f, 983.3f),
                        PathNode.QuadTo(561.5f, 1004.4f, 603.8f, 1004.4f),
                        PathNode.QuadTo(645.4f, 1004.4f, 681.2f, 983.3f),
                        PathNode.QuadTo(716.9f, 962.2f, 738.0f, 926.4f),
                        PathNode.QuadTo(759.1f, 890.7f, 759.1f, 849.0f),
                        PathNode.QuadTo(759.1f, 806.8f, 738.0f, 771.1f),
                        PathNode.QuadTo(716.9f, 735.3f, 681.2f, 714.2f),
                        PathNode.QuadTo(645.4f, 693.1f, 603.8f, 693.1f),
                        PathNode.QuadTo(561.5f, 693.1f, 525.6f, 714.2f),
                        PathNode.QuadTo(489.7f, 735.3f, 468.5f, 771.1f),
                        PathNode.QuadTo(447.4f, 806.8f, 447.4f, 849.0f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _contactsMedium!!
    }

private var _contactsMedium: ImageVector? = null

val COUIIcons.Demibold.Contacts: ImageVector
    get() {
        if (_contactsDemibold != null) return _contactsDemibold!!
        _contactsDemibold = ImageVector.Builder(
            name = "Contacts.Demibold",
            defaultWidth = 24.0f.dp,
            defaultHeight = 24.0f.dp,
            viewportWidth = 1220.4f,
            viewportHeight = 1220.4f,
        ).apply {
            group(scaleY = -1.0f, translationY = 1220.4f) {
                addPath(
                    pathData = listOf(
                        PathNode.MoveTo(1067.7f, 112.2f),
                        PathNode.QuadTo(1094.7f, 126.2f, 1107.7f, 154.2f),
                        PathNode.QuadTo(1115.7f, 168.2f, 1117.2f, 186.2f),
                        PathNode.QuadTo(1118.7f, 204.2f, 1118.7f, 245.2f),
                        PathNode.QuadTo(1118.7f, 287.2f, 1116.7f, 311.7f),
                        PathNode.QuadTo(1114.7f, 336.2f, 1106.7f, 358.2f),
                        PathNode.QuadTo(1099.7f, 379.2f, 1082.7f, 403.2f),
                        PathNode.QuadTo(1065.7f, 427.2f, 1046.7f, 442.2f),
                        PathNode.QuadTo(1027.7f, 456.2f, 1009.7f, 464.7f),
                        PathNode.QuadTo(991.7f, 473.2f, 955.7f, 485.2f),
                        PathNode.QuadTo(787.7f, 542.2f, 610.7f, 542.2f),
                        PathNode.QuadTo(431.7f, 542.2f, 265.7f, 485.2f),
                        PathNode.QuadTo(229.7f, 473.2f, 211.2f, 464.7f),
                        PathNode.QuadTo(192.7f, 456.2f, 173.7f, 442.2f),
                        PathNode.QuadTo(154.7f, 428.2f, 138.2f, 404.7f),
                        PathNode.QuadTo(121.7f, 381.2f, 113.7f, 358.2f),
                        PathNode.QuadTo(105.7f, 336.2f, 103.7f, 311.7f),
                        PathNode.QuadTo(101.7f, 287.2f, 101.7f, 245.2f),
                        PathNode.QuadTo(101.7f, 204.2f, 103.2f, 186.2f),
                        PathNode.QuadTo(104.7f, 168.2f, 112.7f, 154.2f),
                        PathNode.QuadTo(125.7f, 126.2f, 152.7f, 112.2f),
                        PathNode.QuadTo(166.7f, 105.2f, 185.7f, 103.7f),
                        PathNode.QuadTo(204.7f, 102.2f, 243.7f, 102.2f),
                        PathNode.HorizontalTo(976.7f),
                        PathNode.QuadTo(1019.7f, 102.2f, 1036.7f, 103.7f),
                        PathNode.QuadTo(1053.7f, 105.2f, 1067.7f, 112.2f),
                        PathNode.Close,
                        PathNode.MoveTo(214.7f, 234.2f),
                        PathNode.VerticalTo(255.2f),
                        PathNode.QuadTo(214.7f, 274.2f, 215.7f, 289.2f),
                        PathNode.QuadTo(216.7f, 304.2f, 220.7f, 315.2f),
                        PathNode.QuadTo(229.7f, 338.2f, 245.7f, 351.2f),
                        PathNode.QuadTo(254.7f, 359.2f, 265.7f, 364.2f),
                        PathNode.QuadTo(276.7f, 369.2f, 299.7f, 377.2f),
                        PathNode.QuadTo(440.7f, 429.2f, 600.7f, 429.2f),
                        PathNode.QuadTo(773.7f, 429.2f, 924.7f, 368.2f),
                        PathNode.LineTo(933.7f, 364.2f),
                        PathNode.QuadTo(947.7f, 358.2f, 957.7f, 353.2f),
                        PathNode.QuadTo(967.7f, 348.2f, 975.7f, 342.2f),
                        PathNode.QuadTo(992.7f, 327.2f, 1000.7f, 306.2f),
                        PathNode.QuadTo(1003.7f, 296.2f, 1004.7f, 281.2f),
                        PathNode.QuadTo(1005.7f, 266.2f, 1005.7f, 248.2f),
                        PathNode.VerticalTo(234.2f),
                        PathNode.QuadTo(1005.7f, 222.2f, 1002.2f, 218.7f),
                        PathNode.QuadTo(998.7f, 215.2f, 986.7f, 215.2f),
                        PathNode.HorizontalTo(233.7f),
                        PathNode.QuadTo(221.7f, 215.2f, 218.2f, 218.7f),
                        PathNode.QuadTo(214.7f, 222.2f, 214.7f, 234.2f),
                        PathNode.Close,
                        PathNode.MoveTo(871.7f, 857.2f),
                        PathNode.QuadTo(871.7f, 927.2f, 836.7f, 987.2f),
                        PathNode.QuadTo(801.7f, 1047.2f, 741.7f, 1082.7f),
                        PathNode.QuadTo(681.7f, 1118.2f, 610.7f, 1118.2f),
                        PathNode.QuadTo(539.7f, 1118.2f, 479.2f, 1082.7f),
                        PathNode.QuadTo(418.7f, 1047.2f, 383.7f, 987.2f),
                        PathNode.QuadTo(348.7f, 927.2f, 348.7f, 857.2f),
                        PathNode.QuadTo(348.7f, 786.2f, 383.7f, 726.2f),
                        PathNode.QuadTo(418.7f, 666.2f, 479.2f, 631.2f),
                        PathNode.QuadTo(539.7f, 596.2f, 610.7f, 596.2f),
                        PathNode.QuadTo(681.7f, 596.2f, 741.7f, 631.2f),
                        PathNode.QuadTo(801.7f, 666.2f, 836.7f, 726.2f),
                        PathNode.QuadTo(871.7f, 786.2f, 871.7f, 857.2f),
                        PathNode.Close,
                        PathNode.MoveTo(459.7f, 857.2f),
                        PathNode.QuadTo(459.7f, 897.2f, 480.2f, 931.7f),
                        PathNode.QuadTo(500.7f, 966.2f, 535.2f, 986.7f),
                        PathNode.QuadTo(569.7f, 1007.2f, 610.7f, 1007.2f),
                        PathNode.QuadTo(650.7f, 1007.2f, 685.2f, 986.7f),
                        PathNode.QuadTo(719.7f, 966.2f, 740.2f, 931.7f),
                        PathNode.QuadTo(760.7f, 897.2f, 760.7f, 857.2f),
                        PathNode.QuadTo(760.7f, 816.2f, 740.2f, 781.7f),
                        PathNode.QuadTo(719.7f, 747.2f, 685.2f, 726.7f),
                        PathNode.QuadTo(650.7f, 706.2f, 610.7f, 706.2f),
                        PathNode.QuadTo(569.7f, 706.2f, 535.2f, 726.7f),
                        PathNode.QuadTo(500.7f, 747.2f, 480.2f, 781.7f),
                        PathNode.QuadTo(459.7f, 816.2f, 459.7f, 857.2f),
                        PathNode.Close,
                    ),
                    fill = SolidColor(Color.Black),
                    fillAlpha = 1f,
                    pathFillType = PathFillType.NonZero,
                )
            }
        }.build()
        return _contactsDemibold!!
    }

private var _contactsDemibold: ImageVector? = null
